import { GridCellProps } from '@progress/kendo-react-grid';
import { FC, useMemo } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';

const RemainingGlBalanceCell: FC<GridCellProps> = (props) => {
  const { dataItem, field = '' } = props;
  const { displayValue } = useGridCellDisplayValue(props);
  const cost = useMemo(() => dataItem?.[field], [dataItem, field]);
  const isNull = dataItem[field] == null;
  const overridenProps = useMemo(
    () => ({
      ...props,
      className: `${props?.className} ${
        cost < 0 && !isNull && 'text-red-600 bg-error bg-opacity-25'
      }`,
    }),
    [cost, isNull, props]
  );
  const formattedValue = isNull ? '' : displayValue;

  return (
    <GridCellBase {...overridenProps} style={{ textAlign: 'right' }} title={formattedValue}>
      <p className={`${isNull ? 'text-left' : 'text-right'} `}>{formattedValue}</p>
    </GridCellBase>
  );
};

export default RemainingGlBalanceCell;
